import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	state: {
		// 登录状态
		loginInfo: {
			id: 0,
			name: ''
		},
		// 管理员状态,1，在线；0，离线
		managerStatus:1,
		
		// 客服在线状态
		customOnline: {
			
		},
		
		// 当前的聊天对象
		chatFans:{
			
		},

		// 最新的聊天记录
		currentChatMsg: {
			id: 0,
			from_id: 0,
			fans_wx_photo: '',
			from_name: '',
			is_me: 0,
			send_time: '',
			content: '',
			type: '',
			is_send: 1,
			is_update: 0
		},

		// 最新的最近聊天记录
		currentRecentlyMsg: {
			id: 0,
			account_open_id: "",
			friends_open_id: "",
			friend_or_cluster_id: 0,
			friend_img: "",
			friend_name: "",
			chat_type: 1,
			last_chat_msg: "",
			last_chat_msg_type: "text",
			last_modified_time: 0,
			is_new: 1,
			no_read_num:0,
			is_me: 0
		},
		
		// 其他事件类型统一状态
		otherEvent:{},
		
		// 预览文件-图片和视频
		previewFile:{
			type:'',
			data:[],
			index: 0
		},
		
		// 未读评论/点赞信息
		mReply:[]
	},
	mutations: {
		// 保存登录信息
		saveLoginInfo(state, param) {
			state.loginInfo.id = param.id
			state.loginInfo.name = param.name
		},

		// 更新客服在线状态
		updateCustomOnline(state, param) {
			state.customOnline = param.obj
		},
		
		// 更管理员在线状态
		updatemManagerStatus(state, param) {
			state.managerStatus = parseInt(param)
		},
		
		// 更新当前的聊天对象
		updateChatFans(state, param) {
			state.chatFans = param
		},

		// 更改最新的聊天记录
		updateCurrentChatMsg(state, param) {
			state.currentChatMsg = param
		},
		
		// 更改最新的聊天记录
		updateCurrentRecentlyMsg(state, param) {
			state.currentRecentlyMsg = param
		},
		
		// 更改其他事件类型
		updateOtherEvent(state, param) {
			state.otherEvent = param
		},
		
		// 更改预览图数据
		updatePreviewFile(state, param) {
			state.previewFile = param
		},
		
		// 更改未读评论数据
		updateMReply(state, param){
			if(param.type === undefined || param.data === undefined){
				return
			}
			if(param.type === 'add'){
				state.mReply.push(param.data)
			}else if(param.type === 'clear'){
				state.mReply = []
			}
		}
	},
	actions: {},
	modules: {},
	getters: {

	}
})
